import { render, staticRenderFns } from "./BraintreeHostedFieldsForm.vue?vue&type=template&id=4f8c20d1&scoped=true"
import script from "./BraintreeHostedFieldsForm.vue?vue&type=script&lang=js"
export * from "./BraintreeHostedFieldsForm.vue?vue&type=script&lang=js"
import style0 from "./BraintreeHostedFieldsForm.vue?vue&type=style&index=0&id=4f8c20d1&prod&lang=scss&scoped=true"
import style1 from "./BraintreeHostedFieldsForm.vue?vue&type=style&index=1&id=4f8c20d1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8c20d1",
  null
  
)

export default component.exports